export default {
    // UPPER 100s
    t110: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t109: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t108: {
        scaling: 3,
        pockets: 6,
        side: 'left',
    },
    t107: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t106: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t105: {
        scaling: 5,
        pockets: 4,
        side: 'left',
    },
    t104: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t103: {
        scaling: 3.5,
        pockets: 4,
        side: 'left',
    },
    t102: {
        scaling: 4,
        pockets: 4,
        side: 'left',
    },
    t101: {
        scaling: 5,
        pockets: 4,
        side: 'left',
    },

    // UPPER 200s
    t201: {
        scaling: 4.5,
        pockets: 4,
        side: 'right',
    },
    t202: {
        scaling: 4.5,
        pockets: 4,
        side: 'right',
    },
    t203: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t204: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t205: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t206: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t207: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t208: {
        scaling: 3,
        pockets: 6,
        side: 'right',
    },
    t209: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t210: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },

    // LOWER 400s
    t411: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t410: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t409: {
        scaling: 3,
        pockets: 6,
        side: 'left',
    },
    t408: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t407: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t406: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t405: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t404: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t403: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t402: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },
    t401: {
        scaling: 3,
        pockets: 4,
        side: 'left',
    },

    // LOWER 300s
    t301: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t302: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t303: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t304: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t305: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t306: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t307: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t308: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t309: {
        scaling: 3,
        pockets: 6,
        side: 'right',
    },
    t310: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
    t311: {
        scaling: 3,
        pockets: 4,
        side: 'right',
    },
};
